import { render, staticRenderFns } from "./MapPage.vue?vue&type=template&id=4bf4b5da"
import script from "./MapPage.vue?vue&type=script&lang=js"
export * from "./MapPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports